import React from 'react';
import numbro from 'numbro';

import {
  CurrencyType,
  getCurrencyDetails,
  StaminaType,
} from '../../../constants/currencies';
import { BalanceType } from '../../../models/Base';
import { Profile } from '../../../models/UserStore';
import { AvatarNode } from '../AvatarNode';
import { PngIcon } from '../PngIcon';

import styles from './AssetDisplayBar.module.css';

export type CurrencyAmount = {
  type: CurrencyType;
  amount: number;
};

type AssetDisplayBarProps = {
  profile: Profile | undefined | null;
  currencies: CurrencyAmount[];
};

export const currencyAmonuts = (
  {
    gameStamina,
    creationStamina,
    token,
    joyPoint,
    breadSlice,
  }: {
    gameStamina?: number;
    creationStamina?: number;
    token?: number;
    joyPoint?: number;
    breadSlice?: number;
  },
  currencies: CurrencyType[] = [
    StaminaType.GameStamina,
    StaminaType.CreationStamina,
    BalanceType.Token,
    BalanceType.JoyPoint,
    BalanceType.BreadSlice,
  ],
) =>
  currencies
    .map((currency) => {
      if (currency === StaminaType.GameStamina) {
        return {
          type: StaminaType.GameStamina,
          amount: gameStamina ?? 0,
        };
      }
      if (currency === StaminaType.CreationStamina) {
        return {
          type: StaminaType.CreationStamina,
          amount: creationStamina ?? 0,
        };
      }
      if (currency === BalanceType.Token) {
        return {
          type: BalanceType.Token,
          amount: token ?? 0,
        };
      }
      if (currency === BalanceType.JoyPoint) {
        return {
          type: BalanceType.JoyPoint,
          amount: joyPoint ?? 0,
        };
      }
      if (currency === BalanceType.BreadSlice) {
        return {
          type: BalanceType.BreadSlice,
          amount: breadSlice ?? 0,
        };
      }
      return undefined;
    })
    .filter(Boolean) as CurrencyAmount[];

export const AssetDisplayBar = (props: AssetDisplayBarProps) => {
  const { profile, currencies } = props;

  return (
    <div className={styles.container} onClick={(e) => e.stopPropagation()}>
      {profile ? (
        <div className={styles.avatar}>
          <AvatarNode profile={profile} size={52} />
        </div>
      ) : null}
      <div className={styles.currencyList}>
        {currencies.map(({ type, amount }) => {
          const details = getCurrencyDetails(type);
          return (
            <div key={type} className={styles.currencyItem}>
              <PngIcon
                name={details.icon}
                alt={`${details.displayName} icon`}
                width={24}
                height={24}
                className={styles.icon}
              />
              <span>{numbro(amount).format({ thousandSeparated: true })}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
